module.exports = "/images/vendor/flag-icon-css/flags/1x1/tg.svg?29fa137c095a6ace1adc5d8de4a19309";